import { useEffect } from "react";
import {
  almiOnChairSuccess,
  almiOnChairError,
  windowWithCurtains,
  furryRug,
  daVinciDrawing,
  sideTable,
  background,
} from "../assets/images";
import { SpeechBubble } from "../features/server-status/SpeechBubble";
import { HeaderBanner } from "../shared/components/HeaderBanner";
import { Layout } from "../shared/components/Layout";
import { PreloadedImage } from "../shared/components/PreloadedImage";
import { useProjectsStore } from "../shared/store";
import styles from "./ProjectStatusPage.module.scss";
import { useNavigate } from "react-router-dom";
import { AppPreloader } from "../shared/components/AppPreloader";
import { RecoveryProgressPopup } from "../shared/components/RecoveryProgressPopup";

const ProjectStatusPage = () => {
  const { projectStatus } = useProjectsStore();
  const navigate = useNavigate();
  useEffect(() => {
    if (!projectStatus) {
      navigate("/projects", { replace: true });
    }
  }, [projectStatus, navigate]);
  if (!projectStatus) {
    return <AppPreloader />;
  }
  const config = {
    "project-success": {
      almiSrc: almiOnChairSuccess,
      almiAlt: "Алми на кресле (успех)",
    },
    "project-error": {
      almiSrc: almiOnChairError,
      almiAlt: "Алми на кресле (ошибка)",
    },
  }[projectStatus];

  const headerText =
    projectStatus === "project-success"
      ? "Проекты успешно перенесены"
      : "Что-то пошло не так";
  return (
    <Layout
      customMainClass={styles.searchMain}
      background={background}
      customPlaceholder={styles.placeholder}
      showFooter
    >
      <div className={styles.scene}>
        <HeaderBanner className={styles.headerBanner} type="card">
          {headerText}
        </HeaderBanner>
        <PreloadedImage
          src={windowWithCurtains}
          alt="Окно со шторами"
          className={styles.windowWithCurtains}
          width={593}
          height={887}
          aspectRatio="593 / 887"
        />
        <PreloadedImage
          src={furryRug}
          alt="Ковер"
          className={styles.rug}
          width={1057}
          height={108}
          aspectRatio="1057 / 108"
        />
        <PreloadedImage
          src={config.almiSrc}
          alt={config.almiAlt}
          className={styles.almiOnChair}
          width={471}
          height={590}
          aspectRatio="471 / 590"
        />
        <PreloadedImage
          src={daVinciDrawing}
          alt="Картинка да Винчи"
          className={styles.daVinciPainting}
          width={368.393}
          height={452.748}
          aspectRatio="368.393 / 452.748"
        />
        <PreloadedImage
          src={sideTable}
          alt="Столик"
          className={styles.sideTable}
          width={412}
          height={471}
          aspectRatio="412 / 471"
        />
        <SpeechBubble status={projectStatus} />
      </div>

      <RecoveryProgressPopup />
    </Layout>
  );
};

export default ProjectStatusPage;
